import { FC, Fragment, ReactElement, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Slider from 'react-slick';
import { Typography } from '@mui/material';

import ChevronIcon from '@/Atoms/Icons/Chevron';
import { useIsDesktop } from '@/utils/useResponsive';

import messages from './messages';

import useStyles from './styles';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Step: FC<{
  step: number;
  label: string | ReactElement;
}> = ({ step, label }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.step}>
      <span className={classes.stepNumber}>
        <Typography variant="bodyLgBold">{step}</Typography>
      </span>
      <Typography variant="bodyMd" component="p">
        {label}
      </Typography>
    </div>
  );
};

const Stepper: FC = () => {
  const { classes, cx } = useStyles();
  const isDesktop = useIsDesktop();
  const [stepIndex, setStepIndex] = useState(0);

  const steps = [
    {
      key: 'stepper-item-chooseSherpa',
      step: 1,
      shouldShowChevron: true,
      label: <FormattedMessage {...messages.chooseSherpa} />,
    },
    {
      key: 'stepper-item-planTrial',
      step: 2,
      shouldShowChevron: true,
      label: <FormattedMessage {...messages.planTrial} />,
    },
    {
      key: 'stepper-item-exchangeWithTeam',
      step: 3,
      shouldShowChevron: false,
      label: <FormattedMessage {...messages.exchangeWithTeam} />,
    },
  ];

  return (
    <article className={classes.container}>
      {isDesktop ? (
        <>
          {steps.map((step) => (
            <Fragment key={step.key}>
              <Step {...step} />
              {step.shouldShowChevron && (
                <ChevronIcon className={classes.chevron} />
              )}
            </Fragment>
          ))}
        </>
      ) : (
        <Slider
          className={classes.slider}
          dotsClass={classes.sliderDots}
          infinite={false}
          dots
          speed={500}
          slidesToShow={1.1}
          slidesToScroll={1}
          autoplay={false}
          arrows={false}
          customPaging={(index) => (
            <span
              className={cx({
                [classes.dot]: true,
                [classes.activeDot]: index === stepIndex,
              })}
            />
          )}
          afterChange={(index) => setStepIndex(index)}
        >
          {steps.map((step) => (
            <Step key={step.key} {...step} />
          ))}
        </Slider>
      )}
    </article>
  );
};

export default Stepper;
